import { createContext, useContext } from 'react'

export const FitnessTrackerContext = createContext(null)

export function useFitnessTrackerContext() {
  const context = useContext(FitnessTrackerContext)

  if (!context) {
    throw new Error(
      'useFitnessTrackerContext must be used within a FitnessTrackerProvider'
    )
  }

  return context
}
